// Phase 5Z.27 — Theme toggle button (Sun/Moon)
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      title={isDark ? "Heller Modus" : "Dunkler Modus"}
      aria-label="Theme umschalten"
      className={`relative inline-flex items-center justify-center w-9 h-9 rounded-md border border-zinc-800 hover:bg-zinc-800 transition-colors ${className}`}
    >
      {isDark ? <Moon className="w-4 h-4 text-amber-400" /> : <Sun className="w-4 h-4 text-amber-500" />}
    </button>
  );
}
